<template>
    <v-card max-width="344">
        <v-img
            src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg"
            height="200px"
        ></v-img>
        <v-card-title>
            {{ module.moduleName }}
        </v-card-title>

        <v-card-text
            class="description"
            v-html="module.moduleDesc"
        >
        </v-card-text>

        <v-card-actions>
            <v-btn
                v-show="hasCertificate(module.trainingCertificate)"
                color="blue lighten-2"
                text
                @click="openCertificate(module.moduleId)"
            >
                View Certificate
            </v-btn>
            <v-btn v-if="!isTrainingCompleted(module.trainingStatus)" color="blue lighten-2" text class="ms-auto">
                Take Training
            </v-btn>
            <v-btn v-else color="blue lighten-2" text class="ms-auto">
                View Training
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        props: ['module'],
        data() {
            return {
            };
        },

        methods: {
            openCertificate (moduleId) {
                window.open(
                    this.$vtrainingurl
                    + `/account/certificate-script/cert/render.php?modId=${moduleId}`
                    + `&certUser=${this.$store.state.principal.id}`
                    + ``, '_blank')
            },

            hasCertificate (certificate) {
                let hasCertificate = false;
                if (certificate) {
                    hasCertificate = true;
                }

                return hasCertificate;
            },

            isTrainingCompleted (trainingStatus) {
                let isCompleted = false;

                if (trainingStatus) {
                    isCompleted = trainingStatus.isCompleted;
                }

                return isCompleted;
            }
        }
    };
</script>

<style scoped>
    .description {
        height: 3rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>